export default __webpack_public_path__ + "static/product-b-pressxl-b3bf302f6904b40d00c587a060a77522.jpg";